import React, { Component } from 'react';
import xtend from 'xtend';

import quillMixin from '../events/mixins/QuillToolbar.js';

export default function QuillToolbarHoc (WrappedComponent) {

    return class extends Component {
        constructor (props) {
            super(props);
            this.utils = quillMixin;
        }

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({
                    quillHelpers: this.utils
                }, this.props),
                []
            );
        }
    };
}
